export const LoadingState = () => (
  <div
    className="min-h-screen bg-paper flex items-center justify-center px-6"
    data-testid="loading-state"
  >
    <div className="max-w-md w-full text-center">
      <div className="overline mb-3">Scholar Atlas</div>
      <h1 className="font-display text-4xl sm:text-5xl tracking-tight">
        Reading the <span className="italic text-terracotta">manuscript</span>…
      </h1>
      <p className="text-ink-mute mt-3 text-sm">
        Fetching citation record, publications and co-author network from Google Scholar.
      </p>
      <div className="mt-8 flex items-center justify-center gap-1.5">
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className="w-1.5 h-1.5 rounded-full bg-terracotta animate-pulse"
            style={{ animationDelay: `${i * 0.18}s` }}
          />
        ))}
      </div>
    </div>
  </div>
);

export default LoadingState;
